var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MainSliderWrapper"},[_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[(_vm.currentSlide===0)?_c('AboutUsSlide'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }